import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MFTokenPersona, AccesoDate, PortalAuditorToken, IpCliente, HCEToken, AccesoAplicacionMarkable, CredToken } from 'src/common/acceso';
import { Observable } from 'rxjs';


@Injectable()
export class AplicacionService {

	private readonly APLICACION_BASE_URL: string = environment.backendUrl + '/aplicacion';
	private readonly FIND_ACCESO_BY_USUARIO: string = this.APLICACION_BASE_URL;
	private readonly ACCESO_FAV: string = this.APLICACION_BASE_URL + '/favorita';

	private readonly APLICACION_ACCESO_BASE_URL: string = this.APLICACION_BASE_URL + '/acceso';
	private readonly CREATE_MF_PERSONA_TOKEN: string = this.APLICACION_ACCESO_BASE_URL + '/mf-token-persona';
	private readonly GET_ACCESO_DATE: string = this.APLICACION_ACCESO_BASE_URL + "/date";
	private readonly CREATE_PORTAL_AUDITOR_TOKEN: string = this.APLICACION_ACCESO_BASE_URL + '/portal-auditor-token';
	private readonly CREATE_HCE_TOKEN: string = this.APLICACION_ACCESO_BASE_URL + '/hce-token';
	private readonly CREATE_CRED_TOKEN: string = this.APLICACION_ACCESO_BASE_URL + '/usuario-cred-token';	

	private readonly GET_IP_CLIENTE: string = environment.legacyBaseUrl + '/control-session/ip.php';

	private readonly CONNECTION_TYPE: string = 'connectionType';
	private readonly IP_CLIENTE: string = 'clientIp';
	private readonly ID_APLICACION_MF: string = 'idAplicacionMf';


	constructor( private http: HttpClient ) {
	}

	findAplicaciones( connectionType: string, ipCliente: string ): Observable<AccesoAplicacionMarkable[]> {
		let params: HttpParams = new HttpParams()
			.set( this.CONNECTION_TYPE, connectionType )
			.set( this.IP_CLIENTE, ipCliente );
		return this.http.get<AccesoAplicacionMarkable[]>( this.FIND_ACCESO_BY_USUARIO, { params } );
	}

	createMFPersonaToken( idAplicacionPerfil: number ): Observable<MFTokenPersona> {
		return this.http.post<MFTokenPersona>( this.CREATE_MF_PERSONA_TOKEN, { idAplicacionPerfil } );
	}

	getAccesoDate(): Observable<AccesoDate> {
		return this.http.get<AccesoDate>( this.GET_ACCESO_DATE );
	}

	createPortalAuditorToken( idPersonaFederada: number ): Observable<PortalAuditorToken> {
		return this.http.post<PortalAuditorToken>( this.CREATE_PORTAL_AUDITOR_TOKEN, { idPersonaFederada } );
	}

	addAplicacionFavorita( idAplicacionMf: number, nombreAplicacion: string ): Observable<Object> {
		return this.http.post<Object>( this.ACCESO_FAV, { idAplicacionMf, nombreAplicacion } );
	}

	removeAplicacionFavorita( idAplicacionMf: number ) {
		let params: HttpParams = new HttpParams().set( this.ID_APLICACION_MF, idAplicacionMf.toString() );
		return this.http.delete( this.ACCESO_FAV, { params } );
	}

	getIpCliente(): Observable<IpCliente> {
		return this.http.get<IpCliente>( this.GET_IP_CLIENTE );
	}

	createHCEToken(): Observable<HCEToken> {
		return this.http.post<HCEToken>( this.CREATE_HCE_TOKEN, null );
	}

	createCredToken( ne: string, ce: string ): Observable<CredToken> {
		return this.http.post<CredToken>( this.CREATE_CRED_TOKEN, { ne, ce } );
	}

}